<template>
  <div class="dashboard-shell">
    <AppTopbar />
    <main class="page-shell">
      <div class="container-readable stack-lg">
        
        <!-- Hero Banner עליון בעיצוב המותג -->
        <section class="hero-banner">
          <div class="hero-container">
            <div class="hero-content">
              <router-link to="/" class="back-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path d="M19 12H5M12 19l-7-7 7-7"/>
                </svg>
                חזרה לאזור האישי
              </router-link>

              <h1 class="hero-title">אמצעי תשלום</h1>
              <p class="hero-subtitle">ניהול ועדכון אמצעי התשלום של החשבון בסביבה מאובטחת ומוצפנת.</p>
            </div>
          </div>
        </section>

        <!-- פאנל ניהול ועדכון אמצעי התשלום -->
        <section class="surface card-block payment-panel stack-md">
          
          <!-- כרטיס תצוגה של אמצעי התשלום הנוכחי -->
          <div class="current-payment-card">
            <div class="card-info-group">
              <div class="card-icon-wrap">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
                  <line x1="1" y1="10" x2="23" y2="10"/>
                </svg>
              </div>
              <div class="card-details">
                <span class="card-label">אמצעי תשלום שמוגדר בחשבון</span>
                <div v-if="paymentFourDigits" class="card-digits-wrap">
                  <span class="dots">•••• •••• ••••</span>
                  <span class="digits">{{ paymentFourDigits }}</span>
                </div>
                <span v-else class="empty-digits">עדיין לא נשמר אמצעי תשלום</span>
              </div>
            </div>

            <span class="status-badge" :class="{ active: paymentFourDigits }">
              {{ paymentFourDigits ? 'פעיל' : 'לא מוגדר' }}
            </span>
          </div>

          <!-- אזור טעינת ה-iFrame -->
          <div class="payment-form-container stack-sm">
            <h2 class="section-title">עדכון פרטי אשראי</h2>

            <div v-if="loadingPaymentLink" class="loading-state muted">
              <div class="spinner"></div>
              <span>טוען טופס תשלום מאובטח...</span>
            </div>

            <div v-else-if="iframeUrl" class="iframe-wrap">
              <iframe :src="iframeUrl" class="payment-iframe" frameborder="0" allowpaymentrequest />
            </div>

            <div v-if="paymentError" class="alert-inline stack-sm">
              <p class="error-message">{{ paymentError }}</p>
              <button class="btn btn-primary btn-retry" @click="loadPaymentIframe">לנסות שוב</button>
            </div>
          </div>

        </section>

      </div>
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue'
import AppTopbar from '@/components/AppTopbar.vue'

export default {
  name: 'PaymentMethod',
  components: { AppTopbar, AppFooter },
  data() {
    return {
      loadingPaymentLink: false,
      paymentError: '',
      paymentFourDigits: null,
      iframeUrl: '',
    }
  },
  mounted() {
    if (this.isNull(localStorage.getItem('user_token'))) { this.$router.push('/login'); return }
    this.fetchDashboard()
    this.loadPaymentIframe()
    const err = this.$route?.query?.error
    if (err) {
      this.paymentError = decodeURIComponent(err)
      this.$router.replace({ path: '/payment-method' })
    }
  },
  methods: {
    fetchDashboard() {
      this.api({ action: 'get_my_dashboard_data', method: 'get' }, (response) => {
        if (response?.data?.success) this.paymentFourDigits = response.data.payment_four_digits || null
      })
    },
    closeIframe() {
      this.$router.push({ path: '/', query: { success: encodeURIComponent('אמצעי התשלום עודכן') } })
    },
    loadPaymentIframe() {
      this.loadingPaymentLink = true; this.paymentError = ''
      this.api({ action: 'get_update_payment_link', method: 'get' }, (response) => {
        const link = response?.data?.payment_link ? String(response.data.payment_link).trim() : ''
        if (link) this.iframeUrl = link
        else this.paymentError = 'לא הצלחנו ליצור קישור לעדכון תשלום. נסו שוב.'
        this.loadingPaymentLink = false
      }, () => { this.paymentError = 'אירעה שגיאה זמנית. נסו שוב.'; this.loadingPaymentLink = false })
    },
  }
}
</script>

<style lang="scss" scoped>
@use "@/styles/tokens" as *;

// --- הבאנר העליון (Hero) ---
.hero-banner {
  background: linear-gradient(135deg, $color-brand 0%, lighten($color-brand, 10%) 100%);
  color: #ffffff;
  border-radius: $radius-lg;
  padding: $space-5 $space-6;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
}

.hero-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: $space-4;
  flex-wrap: wrap;
}

.hero-content {
  display: flex;
  flex-direction: column;
  gap: $space-2;
  max-width: 600px;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.88rem;
  margin-bottom: $space-1;
  transition: opacity $transition-fast;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }

  svg {
    transform: rotate(180deg);
  }
}

.hero-title {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.2;
}

.hero-subtitle {
  margin: 0;
  color: rgba(255, 255, 255, 0.88);
  font-size: 1rem;
}

// --- פאנל מרכזי ---
.payment-panel {
  border: 1px solid $color-line;
  border-radius: $radius-md;
  padding: $space-5;
}

// --- כרטיס אמצעי התשלום הנוכחי ---
.current-payment-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: $space-4 $space-5;
  background: #fdfbff;
  border: 1.5px solid $color-line;
  border-radius: $radius-md;
  transition: border-color $transition-fast;

  &:hover {
    border-color: lighten($color-brand, 25%);
  }
}

.card-info-group {
  display: flex;
  align-items: center;
  gap: $space-4;
}

.card-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: $radius-sm;
  background: $color-brand-soft;
  color: $color-brand;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.card-details {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.card-label {
  font-size: 0.82rem;
  color: $color-text-muted;
  font-weight: 600;
}

.card-digits-wrap {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.2rem;
  font-weight: 800;
  color: $color-text;
  letter-spacing: 0.05em;

  .dots {
    color: #998fae;
    font-size: 0.9rem;
    letter-spacing: 0.1em;
  }
}

.empty-digits {
  font-size: 1rem;
  font-weight: 600;
  color: $color-text-muted;
}

.status-badge {
  font-size: 0.8rem;
  font-weight: 700;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  background: #f0f0f5;
  color: #6c6283;

  &.active {
    background: #e6f9ee;
    color: #1e6b3a;
  }
}

// --- טופס iFrame ---
.payment-form-container {
  margin-top: $space-4;
  padding-top: $space-4;
  border-top: 1px dashed $color-line;
}

.section-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: $color-text;
  margin: 0 0 $space-2;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: $space-3;
  padding: $space-6 0;

  .spinner {
    width: 32px;
    height: 32px;
    border: 3px solid rgba($color-brand, 0.15);
    border-top-color: $color-brand;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.iframe-wrap {
  border: 1.5px solid $color-line;
  border-radius: $radius-md;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.03);
  transition: border-color $transition-fast;

  &:focus-within {
    border-color: $color-brand;
  }
}

.payment-iframe {
  width: 100%;
  min-height: 520px;
  display: block;
  border: none;
}

// --- הודעות שגיאה ---
.alert-inline {
  border: 1px solid #f0bfd0;
  background: #fff4f8;
  border-radius: $radius-sm;
  padding: $space-4;
  text-align: center;
  margin-top: $space-3;

  .error-message {
    margin: 0 0 $space-3;
    color: $color-danger;
    font-weight: 600;
  }

  .btn-retry {
    align-self: center;
  }
}

// --- רספונסיביות ---
@media (max-width: 680px) {
  .hero-banner {
    padding: $space-4;
  }

  .hero-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .current-payment-card {
    flex-direction: column;
    align-items: flex-start;
    gap: $space-3;
  }

  .status-badge {
    align-self: flex-end;
  }

  .payment-iframe {
    min-height: 480px;
  }
}
</style>